<template>
<div class="chapter">
<div class="inner_page">
<h2 class="top5 sigil_not_in_toc">Die Versuchung des Pescara</h2>
<p class="subtitle">Novelle</p>
<p class="center">1887</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?9a7e758c